export default {
  title: "Saved Configurations",
  can_save_config:
    "You can save up to 8 different, named configurations for the <b class='text-info'>{entity}</b> list.<br>",
  config_limit_reached:
    "<b>You have reached the maximum of 8 saved configurations for <b class='text-info'>{entity}</b> list.</b><br><br>",
  config_explanation:
    "These include the configured columns (6 possible in total) and the filtering used with those columns, if any.",
  favorite_config:
    "You may pick a <b>favourite</b> <i class='q-icon fa-regular fa-star q-mb-xs' aria-hidden='true' role='presentation'></i> which will be used automatically every time the list is opened.",
  section_save_current_config: "Save current configuration",
  section_saved_configs: "Saved configurations",
  label_name: "Name",
}
